'use strict';

require('regenerator-runtime/runtime');

const main = require('integrations/main');

main.baseFiles.menu = require('./components/menu');
main.baseFiles.yotpo = require('./components/yotpo');
main.baseFiles.consentTracking = require('./components/consentTracking');
main.baseFiles.warranty = require('./components/warranty');
main.baseFiles.slider = require('./components/slider').init;
main.baseFiles.base = require('./product/base');
main.baseFiles.timer = require('./components/timer');
main.baseFiles.search = require('./search/search');
main.baseFiles.flyout = require('./components/flyout');
main.baseFiles.clientSideValidation = require('./components/clientSideValidation');
main.baseFiles.backstage = require('./backstage/backstage');
main.baseFiles.antavo = require('./components/antavo');
// Global because the activity grid's Page Designer shell is page-cached (a
// cached render script never re-runs, so its assets.addJs never ships) and the
// grid can sit in an AJAX-rendered region that includes no scripts at all. The
// underscore prefix keeps the builder from also emitting this as its own
// standalone bundle.
main.baseFiles.loyaltyActivities = require('./loyalty/_loyaltyActivities');

// add class to iframe for mobile video display

window.focus();
window.addEventListener("blur", () => {
    setTimeout(() => {
        if (document.activeElement.tagName === "IFRAME") {
            let videoFrameClassList = document.activeElement.classList;
            document.activeElement.classList.toggle("active-iframe");
        }
        
    });
});

let interval = window.setInterval(trackClick, 100);
let inc = 0;
function trackClick() {
    if(document.activeElement == document.querySelector("iframe[title='vimeo-player']")) {
        i++
        window.focus();
    }
}

function initVideoCloseEvent() {
    let theVideoCloseButton = document.querySelector(".product-media-body button.close[data-dismiss='modal']");
    if (theVideoCloseButton) {
        theVideoCloseButton.addEventListener("click", () => {
            let videoFrame = document.querySelector("iframe[title='vimeo-player'].active-iframe");
            if (videoFrame) {
                videoFrame.classList.remove("active-iframe");
                videoFrame.src = videoFrame.src; // reload iframe to stop video
            }
        });
    }
}

function fixBlogTitle() {
    let thePageTitle = document.title;
    if (thePageTitle.includes("Blog Landing Page")) {
        let newTitle = thePageTitle.replace("Blog Landing Page", "The Martin Blog");
        document.title = newTitle;	
    }
}

function isHidden(el) {
    return (el.offsetParent === null)
}
// remove all mention of affirm on retired product PDPs

function removeMentionOfAffirmRetired() {
    let retiredBadge = document.querySelector('.primary-images span.badge-product');
    if (retiredBadge && retiredBadge.innerHTML == "RETIRED") {
        const affirmElements = document.querySelectorAll('.affirm-as-low-as, .checkout-continue .affirm-as-low-as');
        affirmElements.forEach(elem => {
            elem.remove();
        });
    }			
}

// remove affirm messaging if add to cart button is hidden

function removeAffirmMessagingCart() {
    let addToCartButton = document.querySelector(".btn.add-to-cart");
    if (addToCartButton && isHidden(addToCartButton)) {
        let affirmMessaging = document.querySelectorAll('.affirm-as-low-as, .checkout-continue .affirm-as-low-as');
        affirmMessaging.forEach(el => {
            el.style.visibility = "hidden";
        });
    }
}

function updateAffirmVisibilityVariant() {
    let allAffirmMessaging = document.querySelectorAll('.affirm-as-low-as, .checkout-continue .affirm-as-low-as');
    let HandednessButtons = document.querySelectorAll('button.guitar_Handedness-attribute,button.guitar_Electronics-attribute');
    HandednessButtons.forEach(elem => {
        elem.addEventListener('click', function() {
            setTimeout(function() {
                if (document.querySelector("button.add-to-cart") && document.querySelector(".col-auto.addtocartbutton").classList.contains("d-none")) {
                    allAffirmMessaging.forEach(el => {
                        el.style.visibility = "hidden";
                    });
                } else {
                    allAffirmMessaging.forEach(el => {
                        el.style.visibility = "visible";
                    });
                }
            }, 500);
        });	
    });
}

// remove dark mode on backstage - RW

const removeClassFromBlogs = () => {
    const blogContainer = document.querySelector('.blog.page-designer');
    if (blogContainer && blogContainer.classList.contains("text--white")) {
        blogContainer.classList.remove("text--white");
    }
    const blogContainerHome = document.querySelector('div.experience-component.experience-commerce_assets-wysiwyg > div.col-12.py-5');
    if (blogContainerHome) {
        blogContainerHome.classList.remove("text--white");
    }

    const blogHeadline = document.querySelector('div.experience-component.experience-commerce_assets-wysiwyg > div.px-5.text--white');
    if (blogHeadline) {
        blogHeadline.classList.remove("text--white");
    }
    }

function addReadMoreToShortDescriptions() {
    const shortDescriptions = document.querySelectorAll('.container.product-detail div.mt-3 > p');
    const descButton = document.querySelector("a[data-target='#pdp-flyout-headline-description']");

    if (shortDescriptions.innerHTML !== "") {
        shortDescriptions.forEach(desc => {
            const readMore = document.createElement('a');
            readMore.href = '#';
            readMore.textContent = 'Read More';
            readMore.style.display = 'inline-block';
            readMore.style.marginTop = '10px';
            readMore.addEventListener('click', function(e) {
                e.preventDefault();
                descButton.click();
            });
            desc.parentNode.insertBefore(readMore, desc.nextSibling);
        });
    }
}

document.addEventListener("DOMContentLoaded", function(e) {
    removeClassFromBlogs();
    removeMentionOfAffirmRetired();
    removeAffirmMessagingCart();
    updateAffirmVisibilityVariant();
    fixBlogTitle();
    addReadMoreToShortDescriptions();
    initVideoCloseEvent();
});

module.exports = main;
